import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-active-message-v2",
  "use": "icon-active-message-v2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-active-message-v2\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path fill=\"#008FFF\" d=\"M20 3.2a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-5l-2.293 2.293a1 1 0 0 1-1.414 0L9 18.2H4a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h16zm-6 8H7a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm3-4H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol